import { render, staticRenderFns } from "./OperateWork.vue?vue&type=template&id=35c2c30a&scoped=true"
import script from "./OperateWork.vue?vue&type=script&lang=js"
export * from "./OperateWork.vue?vue&type=script&lang=js"
import style0 from "./OperateWork.vue?vue&type=style&index=0&id=35c2c30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c2c30a",
  null
  
)

export default component.exports